import axios from 'axios';
import { useState, useEffect } from "react";
import './App.css';
import { WeatherData } from "./type/types";
import styled from "styled-components";
import InsertCityName from "./components/InsertCityName";
import PrintWeather from "./components/PrintWeather";
import Clouds from './assets/cloud.jpg';
import Clear from './assets/clear.jpg';
import Rain from './assets/rain.jpg';
import Drizzle from './assets/drizzle.jpg';
import Snow from './assets/snow.jpg';
import Mist from './assets/mist.jpg';
import Haze from './assets/haze.jpg';
import Thunderstorm from './assets/thunderstorm.jpg';
import Fog from './assets/fog.jpg';


const weatherImg:{[key:string]:string} = {
    Clouds: Clouds,
    Clear: Clear,
    Rain :Rain,
    Drizzle: Drizzle,
    Snow: Snow,
    Mist: Mist,
    Haze: Haze,
    Fog: Fog,
    Thunderstorm: Thunderstorm
}

const api = {
    url : process.env.REACT_APP_API_URL,
    api_key: process.env.REACT_APP_WEATHER_API_KEY
}

const App = () => {
    // console.log(api.api_key, api.url);

    const[cityName, setCityName] = useState("seoul");
    const[weather, setWeather] = useState<WeatherData>();
    const[weatherName, setWeatherName] = useState("");
    const[country, setCountry] = useState();
    const[temp, setTemp] = useState();

    const getWeather = async () => {
        const response = await axios.get(
            `${api.url}?q=${cityName}&units=metric&appid=${api.api_key}`
        );

        setWeather(response.data);
        setWeatherName(response.data.weather[0].main);
        setCountry(response.data.sys.country);
        setTemp(response.data.main.temp);
    };

    // console.log("app", weather, weather?.sys.country);
    console.log("app", weather, country);

    useEffect(()=>{
        setTimeout(()=> getWeather(), 600);
    }, [cityName]);

  //   return (
  //       <Container img={weatherImg[weatherName]}>
  //           <Box>
  //               <ProjectTitle>{`Simple Weather App`}</ProjectTitle>
  //               <PrintWeather weather = {weather}  country = {country}/>
  //               <InsertCityName setCityName = {setCityName} />
  //           </Box>
  //       </Container>
  // );
    if(weather) {
        return (
            <Container img={weatherImg[weatherName]}>
                <Box>
                    <ProjectTitle>{`Simple Weather App`}</ProjectTitle>
                    <PrintWeather weather = {weather}  country = {country}/>
                    <InsertCityName setCityName = {setCityName} />
                </Box>
            </Container>
        );
    } else {
        return (<Container img={''}>
            {/*<Box>*/}
                {/*<ProjectTitle>LOADING...</ProjectTitle>*/}
                <div className="lds-heart">
                    <div></div>
                </div>
            {/*</Box>*/}
        </Container>)
    }

}

export default App;

interface ContainerProps {
    img: string | undefined;
}

const Container = styled.div<ContainerProps>`
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url(${(props) => props.img});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    transition: all 0.2s ease-in;
    `;
const Box = styled.div`
    text-align:center;
    border: 3px solid white;
    border-radius: 10px;
    padding: 5rem;
    background-color: rgba(255, 255, 255, 0.3);
    `;
const ProjectTitle = styled.h1`
    color: black;
    margin: 1rem;
    font-family: Recoleta;
`;
